import ResponsiveAppBarLogout from "./components/ResponsiveAppBar/ResponsiveAppBarLogout";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import PullTab from "./components/MultiEntitySwitcher/PullTab";
import ResponsiveAppBar from "./components/ResponsiveAppBar";
import Loader from "./components/Loader/Index";

function AppBar() {
  const location = useLocation();
  const { switcherShouldBeEnabled } = useSelector(
    (s) => s.multiEntitySwitcherSlice,
  );
  const { conciergeLoading } = useSelector((state) => state.multientity);
  const [isActive, setIsActive] = useState(false);
  const [cardTimeout, setCardTimeout] = useState(false);
  const isNotPrimary =
    JSON.parse(sessionStorage.getItem("suppressPullTab")) ?? false;

  return (
    <div className="App">
      <div>
        {location.pathname !== "/multi_entity" &&
          location.pathname !== "/multi_entity_viewAll" && (
            <>
              {!isNotPrimary &&
                (isActive || conciergeLoading || cardTimeout) && (
                  <div
                    className="fixed  top-top-base left-left-base bg-PopUp-BackDrop opacity-dark-opacity w-full-width h-full-height"
                    style={{
                      zIndex: "var(--max-zindex)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    {(conciergeLoading || cardTimeout) && (
                      <>
                        <Loader />
                        <h5 className="text-font-sm text-text-secondary">
                          Swapping entity
                        </h5>
                      </>
                    )}
                  </div>
                )}
              <ResponsiveAppBar />
              {!isNotPrimary && (
                <PullTab
                  disabled={!switcherShouldBeEnabled}
                  isActive={isActive}
                  setIsActive={setIsActive}
                  conciergeLoading={conciergeLoading}
                  cardTimeout={cardTimeout}
                  setCardTimeout={setCardTimeout}
                />
              )}
            </>
          )}
      </div>
      <Outlet />
    </div>
  );
}

export default AppBar;
